const environmentsConfig = {
  local: {
    ENVIRONMENT: 'local',
    DOMAIN: 'dev-zto14ngg.auth0.com',
    CLIENT_ID: 'unBraUTnILVuz9O2QS9lOfU6LgIZ1hgT',
    AUDIENCE: 'https://api.local.carejourney.com/',
    WS_API_URL: 'wss://cg5rc76vzj.execute-api.us-east-1.amazonaws.com/sandbox', // Replace with developer specific URL for local development
    HTTP_API_URL:
      'https://nsr9gdvn6f.execute-api.us-east-1.amazonaws.com/sandbox', // Replace with developer specific URL for local development
    // WS_API_URL: 'wss://pneg3m11rj.execute-api.us-east-1.amazonaws.com/haroun', // Example
    // HTTP_API_URL:
    //   'https://70vfxayed7.execute-api.us-east-1.amazonaws.com/haroun', // Example
    LAUNCH_DARKLY_CLIENT_ID: '62a74c5cd369e413a0519df9',
    LAUNCH_DARKLY_HASH:
      '69b0e6196f6ec543fdd7179c3b6735cf26b3e77165f02c60393ab68f9ed4da5b',
    CJ_HOME_BASE_URL: 'https://home-dev.carejourney.com',
  },
  dev: {
    ENVIRONMENT: 'dev',
    DOMAIN: 'auth-dev.carejourney.com',
    CLIENT_ID: 'LK7hEAqDqvNCYCU1n1Ga2pPdr0jussIm',
    AUDIENCE: 'https://api.dev.carejourney.com/',
    WS_API_URL: 'wss://pat.dev.carejourney.ai',
    HTTP_API_URL: 'https://api.dev.carejourney.ai/chat',
    LAUNCH_DARKLY_CLIENT_ID: '62a0e68a15f4031531a090ba',
    CJ_HOME_BASE_URL: 'https://home-dev.carejourney.com',
  },
  tst: {
    ENVIRONMENT: 'tst',
    DOMAIN: 'auth-tst.carejourney.com',
    CLIENT_ID: 'oPsXiic1tnqrddjlQpImoQa301gG0sGR',
    AUDIENCE: 'https://api.tst.carejourney.com/',
    WS_API_URL: 'wss://pat.tst.carejourney.ai',
    HTTP_API_URL: 'https://api.tst.carejourney.ai/chat',
    LAUNCH_DARKLY_CLIENT_ID: '62a0e69c8f0e7b14f7358502',
    CJ_HOME_BASE_URL: 'https://home-tst.carejourney.com',
  },
  int: {
    ENVIRONMENT: 'int',
    DOMAIN: 'auth-int.carejourney.com',
    CLIENT_ID: 'oAYfRdVdDwqnG6LLqgw55yDA7b7zHFF0',
    AUDIENCE: 'https://api.int.carejourney.com/',
    WS_API_URL: 'wss://pat.int.carejourney.ai',
    HTTP_API_URL: 'https://api.int.carejourney.ai/chat',
    LAUNCH_DARKLY_CLIENT_ID: '62a0e69240d0e4154e84053d',
    CJ_HOME_BASE_URL: 'https://home-int.carejourney.com',
  },
  prod: {
    ENVIRONMENT: 'prod',
    DOMAIN: 'auth.carejourney.com',
    CLIENT_ID: 'RgZSf6tsWHi5vjs0nWVqJ5JoowrV4fYP',
    AUDIENCE: 'https://api.prod.carejourney.com/',
    WS_API_URL: 'wss://pat.prod.carejourney.ai',
    HTTP_API_URL: 'https://api.prod.carejourney.ai/chat',
    LAUNCH_DARKLY_CLIENT_ID: '6287e078ec20a1154b92d031',
    CJ_HOME_BASE_URL: 'https://home.carejourney.com',
  },
};

const env = process.env.REACT_APP_STAGE || 'local';
export const config = environmentsConfig[env];

export const VBC_SUGGESTED_QUESTIONS = [
  'Show me the best PCPs in a 8 mile radius from my address VBC',
  'How far is the doctor from my location?',
  'Top 10 providers that prescribe avastin',
  'Is there any provider that accepts UnitedHealthcare insurance?',
  'Show me the best PCPs in a 8 mile radius from my address',
];

export const PROVIDER_SUGGESTED_QUESTIONS = [
  'Who is the best doctor for treating back pain in Arlington, VA?',
  'Find me a neurologist in Pittsburgh, PA.',
  'Lower back pain in Virginia',
  'Can you help me find a cardiologist who practices at Allegheny General Hospital?',
];

export const LANDING_PAGE_INTRO_TEXT = `Need to find the best provider to manage your patient’s COPD, or a high performing doctor who is close to your home and can treat your back pain? Look no further. Our chatbot provides invaluable data and unparalleled access to CareJourney’s market leading analysis on the best performing, low cost, and the most recommended healthcare professionals.`;
export const LANDING_PAGE_CLOSING_TEXT = `Say goodbye to cumbersome searches and hello to streamlined, efficient care management. Elevate your healthcare experience with the CareJourney Provider Chatbot today.`;
export const LANDING_PAGE_TEXT_TITLE = `Introducing Cara, CareJourney’s Provider Chatbot, a powerful tool designed to revolutionize the way care managers and patients access vital healthcare information.`;
export const LD_LOCAL_USER_KEY = 'LDLocalUserKey';

export const USER_AUTHORIZATION_NAMESPACE_KEY =
  'https://carejourney.com/user_authorization';

export const USER_PERMISSIONS_NAMESPACE_KEY =
  'https://carejourney.com/permissions';

export const READ_PROVIDER_MESSAGE_PERMISSION = 'read:chatbot_provider_message';
export const MAX_USER_INPUT_CHARS = 4000;

export const ERROR_PAGE_ENUMS = {
  PASSWORD_EXPIRED: 'password_expired',
  LAUNCH_DARKLY_INIT_FAILURE: 'launch_darkly_init_failure',
};

export const USER_FEEDBACK_TYPES = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
};

export const MESSAGE_FEEDBACK_CONFIG = {
  POSITIVE: {
    title: 'What did you like about this answer?',
    reasons: [
      { key: 'helpful', text: 'This answer was helpful' },
      { key: 'accurate', text: 'The data is accurate' },
      { key: 'fast', text: 'It was a fast response' },
      { key: 'other', text: 'Other' },
    ],
  },
  NEGATIVE: {
    title: 'What was wrong with this answer?',
    reasons: [
      { key: 'not_helpful', text: 'This answer was not helpful' },
      { key: 'inaccurate', text: 'The data is wrong' },
      { key: 'slow', text: 'It took too much time' },
      { key: 'other', text: 'Other' },
    ],
  },
};

export const CONVERSATION_TYPES = {
  PROVIDER: 'PROVIDER',
  VBC: 'VBC',
};

export const MESSAGE_DATA_TYPES = {
  SQL_DATA: 'sql',
  STRING_DATA: 'string',
  JSON_DATA: 'json',
  RELEVANT_SEARCH_PARAMETERS: 'relevantSearchParameters',
};

export const SIMULATED_DATA_TEXT =
  'This status is simulated and for illustrative purposes only. It does not reflect the current availability of the doctor.';
